// extracted by mini-css-extract-plugin
export var card = "_8m-0";
export var expandedCard = "_8m-2";
export var paginated = "_8m-1";